import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const SocialMediaField = ({ getFieldValue, handleChange, errors = {} }) => {
  return (
    <Box mb={3} mt={3}>
      <Typography variant="h6" gutterBottom>
        Social Media Links / सोशल मीडिया लिंक
      </Typography>
      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        <TextField
          fullWidth
          label="Facebook URL"
          name="socialMediaLinks.facebook"
          value={getFieldValue("socialMediaLinks.facebook") || ""}
          onChange={handleChange}
          sx={{ flex: 1, minWidth: "300px" }}
          error={!!errors["socialMediaLinks.facebook"]}
          helperText={errors["socialMediaLinks.facebook"]}
        />
        <TextField
          fullWidth
          label="Instagram URL"
          name="socialMediaLinks.instagram"
          value={getFieldValue("socialMediaLinks.instagram") || ""}
          onChange={handleChange}
          sx={{ flex: 1, minWidth: "300px" }}
          error={!!errors["socialMediaLinks.instagram"]}
          helperText={errors["socialMediaLinks.instagram"]}
        />
        <TextField
          fullWidth
          label="Twitter URL"
          name="socialMediaLinks.twitter"
          value={getFieldValue("socialMediaLinks.twitter") || ""}
          onChange={handleChange}
          sx={{ flex: 1, minWidth: "300px" }}
          error={!!errors["socialMediaLinks.twitter"]}
          helperText={errors["socialMediaLinks.twitter"]}
        />
        <TextField
          fullWidth
          label="LinkedIn URL"
          name="socialMediaLinks.linkedin"
          value={getFieldValue("socialMediaLinks.linkedin") || ""}
          onChange={handleChange}
          sx={{ flex: 1, minWidth: "300px" }}
          error={!!errors["socialMediaLinks.linkedin"]}
          helperText={errors["socialMediaLinks.linkedin"]}
        />
        <TextField
          fullWidth
          label="YouTube URL"
          name="socialMediaLinks.youtube"
          value={getFieldValue("socialMediaLinks.youtube") || ""}
          onChange={handleChange}
          sx={{ flex: 1, minWidth: "300px" }}
          error={!!errors["socialMediaLinks.youtube"]}
          helperText={errors["socialMediaLinks.youtube"]}
        />
      </Box>
    </Box>
  );
};

export default SocialMediaField;
